import React, { useEffect, useState } from 'react'
import type { NextPage } from 'next'
import Head from 'next/head'
import Header from '../components/Header/Header'
import LandMap from '../components/LandMap/LandMap'

const Map: NextPage = () => {
    return (
        <>
            <Head>
                <title>Explore the metaverse</title>
            </Head>
            <Header floating={true} />
            <LandMap />
        </>
    )
}

export default Map
